// extracted by mini-css-extract-plugin
export default {"popup":"Popup_popup__EDLru","show":"Popup_show__WwG1p"};